// removed by extract-text-webpack-plugin
module.exports = {"pageContainer":"CE9ylDXEEbh22AZoSERfH","collectionList":"_3OQrxMociDvgoqQGUBov5r","collectionDetail":"_2VBNydvKdTikZEmRupKBAd","header":"_34n2kqAUXt2up0s5vUivMZ","left":"_HfgDKKjTF_AYjSy5FDie","title":"_1iBr_P7TIVPpARAcVp-qRM","border":"_3s_eWjG3QEarq4B_PLfzM3","listCollection":"_3IyMXlpAuuWFrGJ--MXhtQ","fakeBottomPadding":"_3qIZzZuBRXGxS9e0mzzXb9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Collection/CollectionPage.scss
// module id = 446
// module chunks = 0